import { Box } from "@bca/ui-library";

import GavelSVG from "../Icons/GavelSVG";
import CarSVG from "../Icons/CarSVG";

const TabContent = ({
  index,
  day,
  saleCount,
  lotsCount,
  isActive,
}: {
  index: number;
  day: Date;
  saleCount?: number;
  lotsCount?: number;
  isActive?: boolean;
}) => {
  const renderDay = () => {
    if (index === 0) {
      return "Today";
    }
    if (index === 1) {
      return "Tomorrow";
    }
    return day.toLocaleString("en-GB", {
      weekday: "long",
    });
  };

  return (
    <Box display="flex" flexWrap="wrap" justifyContent="center" height="100%">
      <span style={{ fontSize: "18px", fontWeight: 500, width: "100%" }}>
        {renderDay()}
      </span>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        mt="4px"
        mr="18px"
      >
        {saleCount >= 0 && (
          <GavelSVG
            fill={isActive ? "#2196f3" : "#64798c"}
            height="14px"
            width="14px"
            mr="6px"
          ></GavelSVG>
        )}
        {saleCount >= 0 && (
          <span style={{ fontSize: "14px", fontWeight: 500 }}>{saleCount}</span>
        )}
      </Box>
      <Box display="flex" alignItems="center" justifyContent="center" mt="4px">
        {lotsCount >= 0 && (
          <CarSVG
            fill={isActive ? "#2196f3" : "#64798c"}
            height="14px"
            width="14px"
          ></CarSVG>
        )}
        {lotsCount >= 0 && (
          <span
            style={{ fontSize: "14px", fontWeight: 500, marginLeft: "6px" }}
          >
            {lotsCount}
          </span>
        )}
      </Box>
    </Box>
  );
};

export default TabContent;
